<template>
	<div class="personal-center-container">
		<img class="personalBgImg" src="../assets/Home/popularBgImg.png" />
		<div class="personal-container">
			<div class="personal-container-menu">
				<img class="avatarImg" :src="userInfo.avatar" v-if="userInfo.avatar" />
				<img class="avatarImg" src="../assets/defaultAvatar.png" v-else />
				<div class="nickname">
					{{userInfo.user_nickname ? userInfo.user_nickname : ''}}
				</div>
				<div class="levelNo">
					<div class="level">
						{{userInfo.level_name ? userInfo.level_name : ''}}
					</div>
					<div class="no">
						NO.{{userInfo.tj_num ? userInfo.tj_num : ''}}
					</div>
				</div>
				<div class="menu">
					<template v-for="item in menuData">
						<div class="menuItem" :class="item.isSel ? 'isActive' : 'isNormal'" :key="item.id"
							@click="handleChange(item)">
							{{item.title}}
							<img class="arrowRight" src="../assets/Personal/iconD.png"
								v-if="item.childList.length == 0 && item.isSel" />
							<img class="arrowUp" src="../assets/Personal/iconE.png"
								v-if="item.childList.length != 0 && !item.isChild" />
							<img class="arrowUp" src="../assets/Personal/iconG.png"
								v-if="item.childList.length != 0 && item.isChild" />
						</div>
						<div class="child" v-if="item.isChild" :key="'child' + item.id">
							<div class="itemChild" :class="child.isSel ? 'isActive' : 'isNormal'"
								v-for="child in item.childList" :key="child.id" @click="handleChangeChild(item,child)">
								{{child.title}}
							</div>
						</div>
					</template>
				</div>
			</div>
			<div class="personal-container-content">
				<UserInfo v-if="curMenu.id == 1"></UserInfo>
				<MyOrder v-if="curMenu.id == 12"></MyOrder>
				<MakeOrder v-if="curMenu.id == 13"></MakeOrder>
				<MarketOrder v-if="curMenu.id == 14"></MarketOrder>
				<IntegralOrder v-if="curMenu.id == 15"></IntegralOrder>
				<Chat v-if="curMenu.id == 3"></Chat>
				<FollowingList v-if="curMenu.id == 4"></FollowingList>
				<Wishlist v-if="curMenu.id == 5"></Wishlist>
				<MySuperTalk v-if="curMenu.id == 6"></MySuperTalk>
				<MyUpdates v-if="curMenu.id == 7"></MyUpdates>
				<MyActivity v-if="curMenu.id == 8" v-show="myActivityShow" @lookDetails="lookActivityDetails">
				</MyActivity>
				<MyActivityDetails v-if="myActivityDetailsShow"
					@close="myActivityDetailsShow = false;myActivityShow = true;goods = {}" :goods="goods">
				</MyActivityDetails>
				<MyVoucher v-if="curMenu.id == 9"></MyVoucher>
				<MyInvoice v-if="curMenu.id == 10" v-show="myInvoiceShow" @lookDetails="lookInvoiceDetails"></MyInvoice>
				<InvoiceDetails v-if="myInvoiceDetailsShow"
					@close="myInvoiceDetailsShow = false;myInvoiceShow = true;goods = {}" :goods="goods">
				</InvoiceDetails>
				<MyIntegral @naviToDetails="naviToDetails" v-show="myIntegralShow" v-if="curMenu.id == 11"></MyIntegral>
				<IntegralGoodsDetails v-if="myIntegralDetailsShow"
					@close="myIntegralDetailsShow = false;myIntegralShow = true;goods = {}"
					@exchange="myIntegralDetailsShow = false;myIntegralExchangeShow = true;goods = $event"
					:goods="goods" />
				<ExchangeIntegralGoods v-if="myIntegralExchangeShow"
					@close="myIntegralExchangeShow = false;myIntegralShow = true;goods = {}" :goods="goods"
					@exchangeSuc="exchangeSuc" @exchangeError="exchangeError" />
			</div>
		</div>


		<el-dialog class="reportDialog" :visible.sync="dialogReportVisible" append-to-body>
			<div slot="title">
				<div class="dislogTitle">
					昵称修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item prop="name">
						<el-input type="text" placeholder="请输入昵称"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="reportDialog" :visible.sync="dialogPhoneVisible" append-to-body>
			<div slot="title">
				<div class="dislogTitle">
					手机号修改
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item prop="name">
						<el-input type="text" placeholder="请输入原手机号"></el-input>
					</el-form-item>
					<el-form-item prop="code">
						<div class="verification-container">
							<input type="text" v-model="verificationCode" placeholder="请输入新手机号"
								class="verification-input" />
							<button type="button" @click="getVerificationCode" class="get-code-btn">获取验证码</button>
						</div>
					</el-form-item>
					<el-form-item prop="name">
						<el-input type="text" placeholder="请输入验证码"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">保存</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog class="addDialog" :visible.sync="dialogAddressVisible" append-to-body>
			<div slot="title">
				<div class="dislogTitle">
					添加收货地址
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="ruleForm" :model="ruleForm" :rules="rules">
					<el-form-item prop="name" label="地址信息:">
						<el-select v-model="ruleForm.employeeId" class="inputBox" placeholder="请选择省/市/区/街道" clearable>
							<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
						</el-select>
					</el-form-item>
					<el-form-item prop="name" label="详细地址:">
						<el-input type="text" placeholder="请输入详细地址"></el-input>
					</el-form-item>
					<el-form-item prop="name" label="收货人姓名:">
						<el-input type="text" placeholder="请输入收货人姓名"></el-input>
					</el-form-item>
					<el-form-item prop="name" label="手机号码:">
						<el-input type="text" placeholder="请输入手机号码"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium"
						@click="submitForm('ruleForm')">保存</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import UserInfo from '../components/UserInfo.vue'
	import MyOrder from '../components/MyOrder.vue'
	import MakeOrder from '../components/MakeOrder.vue'
	import MarketOrder from '../components/MarketOrder.vue'
	import IntegralOrder from '../components/IntegralOrder.vue'
	import Chat from '../components/Chat.vue'
	import FollowingList from '../components/FollowingList.vue'
	import Wishlist from '../components/Wishlist.vue'
	import MySuperTalk from '../components/MySuperTalk.vue'
	import MyUpdates from '../components/MyUpdates.vue'
	import MyActivity from '../components/MyActivity.vue'
	import MyActivityDetails from '../components/MyActivityDetails.vue'
	import MyVoucher from '../components/MyVoucher.vue'
	import MyInvoice from '../components/MyInvoice.vue'
	import InvoiceDetails from '../components/InvoiceDetails.vue'
	import MyIntegral from '../components/MyIntegral.vue'
	import IntegralGoodsDetails from '../components/IntegralGoodsDetails.vue'
	import ExchangeIntegralGoods from '../components/ExchangeIntegralGoods.vue'



	export default {
		name: 'PersonalCenter',
		components: {
			UserInfo,
			MyOrder,
			MakeOrder,
			MarketOrder,
			IntegralOrder,
			Chat,
			FollowingList,
			Wishlist,
			MySuperTalk,
			MyUpdates,
			MyActivity,
			MyActivityDetails,
			MyVoucher,
			MyInvoice,
			InvoiceDetails,
			MyIntegral,
			IntegralGoodsDetails,
			ExchangeIntegralGoods
		},
		data() {
			return {
				myActivityShow: true,
				myActivityDetailsShow: false,
				myInvoiceShow: true,
				myInvoiceDetailsShow: false,
				goods: {},
				myIntegralShow: true,
				myIntegralDetailsShow: false,
				myIntegralExchangeShow: false,
				userInfo: {},
				ruleForm: {},
				rules: {},
				curMenu: {
					id: 1,
					title: '基本信息',
					isSel: true,
					isChild: false,
					childList: []
				},
				verificationCode: '',
				dialogReportVisible: false,
				dialogPhoneVisible: false,
				dialogAddressVisible: false,
				menuData: [{
					id: 1,
					title: '基本信息',
					isSel: true,
					isChild: false,
					childList: []
				}, {
					id: 2,
					title: '我的订单',
					isSel: false,
					isChild: false,
					childList: [{
						id: 12,
						title: '正常图片订单',
						isSel: false,
					}, {
						id: 13,
						title: '定制图片订单',
						isSel: false,
					}, {
						id: 14,
						title: '周边定制订单',
						isSel: false,
					}, {
						id: 15,
						title: '积分订单',
						isSel: false,
					}]
				}, {
					id: 3,
					title: '我的聊天',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 4,
					title: '我的关注',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 5,
					title: '我的心愿单',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 6,
					title: '我的超话',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 7,
					title: '我的动态',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 8,
					title: '我的活动',
					isSel: false,
					childList: []
				}, {
					id: 9,
					title: '我的代金券',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 10,
					title: '我的发票',
					isSel: false,
					isChild: false,
					childList: []
				}, {
					id: 11,
					title: '我的积分',
					isSel: false,
					isChild: false,
					childList: []
				}],
				options: []
			}
		},
		mounted() {
			if (this.$route.query.menuId == 12) {
				this.handleChangeChild(this.menuData[1], {
					id: 12,
					title: '正常图片订单',
					isSel: false,
				})
			}

			if (this.$route.query.menuId == 13) {
				this.handleChangeChild(this.menuData[1], {
					id: 13,
					title: '定制图片订单',
					isSel: false,
				})
			}

			if (this.$route.query.menuId == 14) {
				this.handleChangeChild(this.menuData[1], {
					id: 14,
					title: '周边定制订单',
					isSel: false,
				})
			}

			if (this.$route.query.menuId == 15) {
				this.handleChangeChild(this.menuData[1], {
					id: 15,
					title: '积分订单',
					isSel: false,
				})
			}

			if (this.$route.query.menuId == 3) {
				this.handleChange(this.menuData[2], {
					id: 3,
					title: '我的聊天',
					isSel: false,
				})
			}

			if (this.$route.query.menuId == 5) {
				this.handleChange(this.menuData[4], {
					id: 5,
					title: '我的心愿单',
					isSel: false,
				})
			}
			
			if (this.$route.query.menuId == 9) {
				this.handleChange(this.menuData[8], {
					id: 9,
					title: '我的代金券',
					isSel: false,
				})
			}
			
			if (this.$route.query.menuId == 11) {
				this.handleChangeChild(this.menuData[1], {
					id: 11,
					title: '我的积分',
					isSel: false,
				})
			}
			this.userDetails()
		},
		methods: {
			getVerificationCode() {

			},
			lookActivityDetails(item) {
				this.myActivityShow = false;
				this.myActivityDetailsShow = true;
				this.$nextTick(() => {
					this.goods = item
				})
			},
			lookInvoiceDetails(item) {
				this.myInvoiceShow = false;
				this.myInvoiceDetailsShow = true;
				this.$nextTick(() => {
					this.goods = item
				})
			},
			//兑换成功
			exchangeSuc(data) {
				if (data.cat_type == 1) {
					this.handleChangeChild(this.menuData[1], {
						id: 15,
						title: '积分订单',
						isSel: false,
					})
				} else {
					this.handleChange(this.menuData[8])
				}
			},
			//兑换失败
			exchangeError() {
				this.handleChange(this.menuData[10])
			},
			//查看积分商品详情
			naviToDetails(item) {
				this.myIntegralShow = false
				this.myIntegralDetailsShow = true
				this.myIntegralExchangeShow = false
				this.$nextTick(() => {
					this.goods = item
				})
			},
			userDetails() {
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			handleChange(item) {
				this.menuData.forEach(row => {
					if (!item.childList.length) {
						row.isSel = row.id == item.id ? true : false
						row.childList.forEach(e => {
							e.isSel = false
						})
					} else {
						if (row.id == item.id) {
							row.isChild = row.isChild ? false : true
						}
					}
				})
				if (item.id != 2) {
					this.myActivityShow = true
					this.myActivityDetailsShow = false
					this.myIntegralShow = true
					this.myIntegralDetailsShow = false
					this.myIntegralExchangeShow = false
					this.myInvoiceShow = true
					this.myInvoiceDetailsShow = false
					this.goods = {}
					this.curMenu = item
				}
			},
			handleChangeChild(item, child) {
				this.menuData.forEach(row => {
					if (row.id == item.id) {
						row.isChild = true
						row.childList.forEach(e => {
							e.isSel = e.id == child.id ? true : false
						})
					} else {
						row.isSel = false
						row.childList.forEach(e => {
							e.isSel = false
						})
					}
				})
				this.myActivityShow = true
				this.myActivityDetailsShow = false
				this.myIntegralShow = true
				this.myIntegralDetailsShow = false
				this.myIntegralExchangeShow = false
				this.myInvoiceShow = true
				this.myInvoiceDetailsShow = false
				this.goods = {}
				this.curMenu = child
			}
		}
	}
</script>

<style lang="scss" scoped>
	.personal-center-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
		position: relative;

		.personalBgImg {
			position: absolute;
			width: 100%;
			bottom: 0;
			left: 0;
		}
	}

	.personal-container {
		margin: .32rem auto;
		width: 12rem;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		z-index: 1;

		.personal-container-menu {
			width: 2.3rem;
			display: flex;
			flex-direction: column;
			background: #FFFFFF;
			border-radius: .04rem .04rem;

			.avatarImg {
				margin: .26rem auto 0;
				width: .66rem;
				height: .66rem;
				border-radius: 50%;
				object-fit: cover;
				overflow: hidden;
			}

			.nickname {
				margin: .16rem auto 0;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.levelNo {
				margin: .08rem auto 0;
				display: flex;
				align-items: center;

				.level {
					margin-right: .04rem;
					height: .24rem;
					padding: 0 .08rem;
					background: #E29358;
					border-radius: .12rem;
					font-weight: 500;
					font-size: .12rem;
					color: #FFFFFF;
					line-height: .24rem;
				}

				.no {
					margin-left: .04rem;
					height: .24rem;
					padding: 0 .08rem;
					background: #706614;
					border-radius: .12rem;
					font-weight: 500;
					font-size: .12rem;
					color: #FFFFFF;
					line-height: .24rem;
				}
			}

			.menu {
				margin: .2rem auto;

				.menuItem {
					margin-top: .04rem;
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 1.98rem;
					height: .4rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					line-height: .4rem;
					cursor: pointer;
					border-radius: .04rem;
					padding: 0 .16rem;

					.arrowRight {
						width: .06rem;
						height: .1rem;
					}

					.arrowUp {
						width: .1rem;
						height: .06rem;
					}
				}

				.isActive {
					background: #E29358;
				}

				.isNormal {
					background: #FFFFFF;
				}

				.itemChild {
					margin-top: .04rem;
					display: flex;
					align-items: center;
					width: 1.98rem;
					height: .4rem;
					font-weight: 400;
					font-size: .14rem;
					color: #252525;
					line-height: .4rem;
					border-radius: .04rem;
					padding: 0 .32rem;
					cursor: pointer;
				}
			}
		}
	}

	.personal-container-content {
		width: 9.55rem;
		background: #FFFFFF;
		border-radius: .04rem .04rem;
		overflow: hidden;
	}

	.addDialog {
		::v-deep .el-dialog {
			width: 5.5rem !important;
		}
	}

	.reportDialog,
	.addDialog {

		::v-deep .el-dialog {
			width: 4.58rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.el-form {

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}

						&__label {
							width: 1.2rem;
							font-weight: 400;
							font-size: .14rem;
							color: #252525;
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0rem auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
					}
				}
			}
		}
	}

	.verification-container {
		width: 4.1rem;
		height: .52rem;
		border: .01rem solid #EFD8B8;
		border-radius: 0.04rem;
		padding: 0 0.16rem;
		font-size: 0.14rem;
		color: #333333;
		outline: none;
		display: flex;
		align-items: center;
		justify-content: space-between;

		input {
			width: 3rem;
			font-weight: 400;
			font-size: .14rem;
			color: #252525;
		}
	}

	.verification-input {
		border: none;
		outline: none;
		padding: 0 0;

		font-size: 0.14rem;
		color: #333333;

		&::placeholder {
			color: #999999;
		}
	}

	.get-code-btn {
		padding: 0 0;
		color: #E29358;
		font-size: 0.14rem;
		cursor: pointer;

		&:disabled {
			background: #F5F5F5;
			color: #CCCCCC;
			border-color: #CCCCCC;
			cursor: not-allowed;
		}
	}
</style>